<template>
  <div id="Screening-report" style="margin-left: 10px;">
    <Tabs type="card" :value="activeName" @on-click="handleClick">
      <TabPane :label="item.name" :name="item.code" :key="item.code" v-for="(item, index) in reportTypes" v-if="reportTypes&&reportTypes.length>0" :style="{'max-height': maxHeight, 'overflow-y': 'auto'}">
        <!-- 健康体检报告 -->
        <phccloudReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='phccloud'"/>
        <!-- 天河儿童入学健康检查表 -->
        <tianHeChildrenEnrolmentReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='tianHeChildrenEnrolment'"/>
        <!-- 从化幼儿园体检报告单 -->
        <congHuaKindergartenReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='congHuaKindergarten'"/>
        <!-- 黄埔大学生检查报告 -->
        <huangPuUniversityReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='huangPuUniversity'"/>
        <!-- 小学入学体检报告 -->
        <primaryEnrolmentReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='primaryEnrolment'"/>
        <!-- 中小学健康检查表 -->
        <middlePrimarySecondaryReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='middlePrimarySecondary'"/>
        <!-- 大学生健康检查表 -->
        <universityReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='university'"/>
        <!-- 总检报告 -->
        <generalInspectionReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='generalInspection'"/>
        <!-- 12~30月儿童健康检查记录表 -->
        <monthChildrenReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='monthChildren'"/>
        <!-- 3~6岁儿童健康检查记录表 -->
        <ageChildrenReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='ageChildren'"/>
        <!-- 听力筛查 -->
        <hearingReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='hearing'"/>
        <!-- 视力筛查 -->
        <visionReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='vision'"/>
        <!-- 龋齿筛查 -->
        <dentalCariesReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='dentalCaries'"/>
        <!-- 中耳报告 -->
        <middleEarReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='middleEar'"/>
        <!-- 屈光筛查 -->
        <refractiveReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='refractive'"/>
        <!-- 骨密度筛查 -->
        <bmdReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='bmdReport'"/>
        <!-- DR报告 -->
        <drReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='drReport'"/>
        <!-- 检验报告 -->
        <lisReport :physicalId="physicalId" :barCode="barCode" :reportCode="reportCode" :printData="printData" @on-setReportData="onSetReportData" v-if="item.code==='lisReport'"/>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>

import phccloudReport from "../../printReport/phccloudReport";
import tianHeChildrenEnrolmentReport from "../../printReport/tianHeChildrenEnrolmentReport";
import congHuaKindergartenReport from "../../printReport/congHuaKindergartenReport";
import huangPuUniversityReport from "../../printReport/huangPuUniversityReport";
import primaryEnrolmentReport from "../../printReport/primaryEnrolmentReport";
import middlePrimarySecondaryReport from "../../printReport/middlePrimarySecondaryReport";
import universityReport from "../../printReport/universityReport";
import generalInspectionReport from "../../printReport/generalInspectionReport";
import monthChildrenReport from "../../printReport/monthChildrenReport";
import ageChildrenReport from "../../printReport/ageChildrenReport";
import hearingReport from "../../printReport/hearingReport";
import visionReport from "../../printReport/visionReport";
import dentalCariesReport from "../../printReport/dentalCariesReport";
import middleEarReport from "../../printReport/middleEarReport";
import refractiveReport from "../../printReport/refractiveReport";
import lisReport from "../../printReport/lisReport";
import bmdReport from "../../printReport/bmdReport";
import drReport from "../../printReport/drReport";

export default {
  name: "ScreeningReport",
  components:{
    phccloudReport, tianHeChildrenEnrolmentReport, congHuaKindergartenReport, huangPuUniversityReport,primaryEnrolmentReport, middlePrimarySecondaryReport, universityReport, generalInspectionReport,
    monthChildrenReport, ageChildrenReport, hearingReport, visionReport, dentalCariesReport, middleEarReport, refractiveReport, lisReport, bmdReport, drReport
  },
  props: {
    physicalId:[String,Number],
    barCode:[String,Number],
    conrrentReport:[String],
    reportTypes:{
      type: Array,
      default:()=>[]
    }
  },
  data() {
    return {
      maxHeight: window.innerHeight - 200,
      activeName: '',
      reportCode: '',
      printData:{},
    };
  },
  computed:{

  },
  watch:{
    reportTypes:{
      handler(newVal,oldVal){

      }
    },
    reportCode:{
      handler(newVal,oldVal){
        if(newVal && newVal.length > 0){
          this.$emit("update:conrrentReport", newVal);
        }
      }
    },
  },
  mounted() {
    if(this.$props.reportTypes && this.$props.reportTypes.length > 0){
      this.activeName = this.$props.reportTypes[0].code;
      this.reportCode = this.$props.reportTypes[0].code;
    }

    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.maxHeight = `${height - 250}px`;
      // this.maxHeight = `${height}px`;
    },
    handleClick(tab, event){
      if(this.reportCode === tab){
        this.reportCode = "";
      }
      this.$nextTick(()=>{
        this.reportCode = tab;
      });
    },
    onSetReportData(reportData){
      this.$emit("onSetReportData", reportData);
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-tabs--border-card>.el-tabs__content {
  padding-left: 0px;
}

</style>
